$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_product_extra_template_item' && a === 'list') {
    let product_extra_template_item_modal_lock = false;
    $(document).on(
      'click',
      '#product-extra-template-item-text-modal-button',
      function () {
        if (
          $('#product-extra-template-item-text-registration-form-modal').length
        ) {
          $(
            '#product-extra-template-item-text-registration-form-modal'
          ).remove();
        }

        let locationId = $('body').attr('event_id');
        let productExtraTemplateId = $(this).attr(
          'data-product-extra-template-id'
        );

        if (!product_extra_template_item_modal_lock) {
          product_extra_template_item_modal_lock = true;
          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_product_extra_template_item/get_modal',
            data: {
              location_id: locationId,
              product_extra_template_id: productExtraTemplateId,
            },
          })
            .done(function (data) {
              if (data.html !== undefined && data.html !== null) {
                $('#content').append(data.html);
                $(
                  '#product-extra-template-item-text-registration-form-modal'
                ).modal('show');
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }
              product_extra_template_item_modal_lock = false;
            })
            .always(function () {
              product_extra_template_item_modal_lock = false;
            });
        }
        return false;
      }
    );
  }
});
